import environmentManager from './environment.manager';
import shareApi from '../apis/share.api';
import layerManager from './layer.manager';
import * as layerNames from './layerName';
import pvTrackService from './pvtrack.service';
import { ActivityH5ShareBuilder } from './share/activityH5.share'
import { ActivityShareDataBuilder } from './share/activity.share';
import { PromotionShareDataBuilder } from './share/promotion.share';
import { DealerShareBuilder } from './share/dealer.share';
import { AdviserShareBuilder } from './share/adviser.share';
import { IcsShareDataBuilder } from './share/icsApp.share';
import { TinyEmitter } from 'tiny-emitter';
/**
 * 分享管理
 */
class ShareManager extends TinyEmitter {
  static EVENTS = {
    SHARED_SUCCESS: 'sharedSuccess',
    SHOW_SHARE_PANEL: 'showSharePanel'
  };
  constructor () {
    super();
    this.shareEnv = environmentManager.getEnv();
  }
  init ({
    baseInfo,
    shareInfo
  }) {
    this.dealerId = baseInfo && baseInfo.dealerId || 0;
    this.baseInfo = baseInfo;
    this.shareInfo = shareInfo;
    this.initEvents();
  }
  getEnvInfo () {
    return this.shareEnv.getEnvInfo();
  }
  shareCount () {
    shareApi.shareCount(this.dealerId);
    pvTrackService.pvTrackLogger({
      action: 'arhall_fenxiang1_click',
      basic: { type: 'click' },
      extend: { succ: '1' }
    });
  }
  appCustomerShare () {
    if(this.activityH5){
      this.showShare(this.activityH5Data);
    }else{
      if (this.promotionShare) {
        this.showShare(this.promotionShareData);
      } else {
        this.shareEnv.getEnvInfo().then(function ({ env }) {
          if (env === 'icsApp') {
            layerManager.open(layerNames.ICSAPP_SHARE_PANEL, {});
          } else {
            layerManager.open(layerNames.SHARE_PANEL, { options: { type: 1 } });
            pvTrackService.pvTrackLogger({
              action: 'ZNZT_APP_activity_14',
              basic: { type: 'click' },
              extend: {}
            });
          }
        });
      }
    }

  }
  /**
   * 获取分享
   */
  initEvents () {
    this.shareEnv.subscribe({
      shareSuccess: () => {
        this.shareCount();
        this.emit(ShareManager.EVENTS.SHARED_SUCCESS);
      },
      showCustomerShare: () => this.appCustomerShare()
    });
  }
  /**
   * 设置普通分享
  */
  setDefaultShare () {
    let share = this.shareEnv;
    const shareInfo = this.shareInfo;
    const dealerShareBuilder = new DealerShareBuilder({
      dealerInfo: this.baseInfo,
      shareInfo
    });
    const shareData = dealerShareBuilder.buildShareData();
    share.setShareData(shareData);
  }
  /**
   * 根据顾问信息设置分享
   * @param {*} adviserInfo
   */
  setAdviserShare (adviserInfo) {
    let share = this.shareEnv;
    const shareInfo = this.shareInfo;
    const adviserShareBuilder = new AdviserShareBuilder({
      dealerInfo: this.baseInfo, adviserInfo, shareInfo
    });
    const shareData = adviserShareBuilder.buildShareData();
    share.setShareData(shareData);
  }
  /**
   * 设置i车商分享信息
   * @param {*} adviserInfo 顾问信息
   * @param { boolean } hasVrRealtime 是否开通带看
   * @param { string } channelName 渠道名称
   */
  setIcsAppShare ({ adviserInfo, dealerHasRtc, saleHasRtc, channelName, shareType = '', path = '' }) {
    let share = this.shareEnv;
    const shareInfo = this.shareInfo;
    const icsShareDataBuilder = new IcsShareDataBuilder({
      dealerInfo: this.baseInfo,
      adviserInfo,
      dealerHasRtc,
      saleHasRtc,
      shareInfo,
      channelName,
      shareType,
      path
    });
    const shareData = icsShareDataBuilder.buildShareData();
    share.setShareData(shareData);
  }
  /**
   * 展示分享面板
   * @param {Object} opts
   */
  showShare (opts) {
    this.shareEnv.showShare(opts);
  }
  /**
   * 保存分享图片
   */
  saveShareImage (opts) {
    this.shareEnv.saveShareImage(opts);
  }
  /**
   * 展示活动分享信息
   * @param {*} params 
   */
  showActivitySharePanel (params) {
    let shareData = this.shareEnv.getShareData();
    const shareLink = shareData.link;
    const activityShareManager = new ActivityShareDataBuilder({
      dealerInfo: this.baseInfo,
      shareInfo: this.shareInfo,
      shareLink, activityInfo: params
    });
    const activityShareData = activityShareManager.buildShareData();
    this.showShare(activityShareData);
  }
  /**
   * 设置促销分享
   */
  setPromotionShare (actId, title, icon, remainDays, openType) {
    this.promotionShare = true;
    let shareData = this.shareEnv.getShareData();
    const shareInfo = this.shareInfo;
    const promotionShareManager = new PromotionShareDataBuilder({
      dealerInfo: this.baseInfo, shareInfo, promotionInfo: { remainDays, openType, actId, title, icon }, shareLink: shareData.link
    });
    this.promotionShareData = promotionShareManager.buildShareData();
  }
  /**
   * 取消促销详情分享设置
   */
  cancelPromotionShare () {
    this.promotionShare = false;
  }
  setActivityH5(activityInfo){
    this.activityH5 = true;
    const share = this.shareEnv;
    let shareData = share.getShareData();
    const shareLink = shareData.link;
    const activityH5Manager = new ActivityH5ShareBuilder({
      dealerInfo: this.baseInfo,
      shareInfo: this.shareInfo,
      activityInfo,
      shareLink
    });
    this.activityH5Data = activityH5Manager.buildShareData();
    share.setShareData(this.activityH5Data);
  }
};
const shareManager = new ShareManager();
export { ShareManager, shareManager };
export default shareManager;
